import React, { Component } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import Button from '@material-ui/core/Button';

// eslint-disable-next-line
import style from './_style.css';

class WhiteButton extends Component {
    render() {
        return (
            <Button
                variant="contained"
                onClick={this.props.onClick}
                className={classNames('bg_white', 'bluebutton', this.props.className)}
            >
                <span className={'barlow_semibold c_bluish'}>
                    <FormattedMessage id={this.props.id} />
                </span>
            </Button>
        );
    }
}

export default WhiteButton;



// WEBPACK FOOTER //
// ./src/components/buttons/WhiteButton.js